// extracted by mini-css-extract-plugin
module.exports = {"list":"InvoiceUsers_list__f0kfe","item":"InvoiceUsers_item___NdCd","item__title":"InvoiceUsers_item__title__lyoy5"};